// @flow
import { Component } from 'react';
import SbEditable from 'storyblok-react';

class StoryblokEditorWithErrorBoundary extends Component<
  *,
  { hasError: boolean }
> {
  constructor(props: *) {
    super(props);
    this.state = { hasError: false };
  }

  static getDerivedStateFromError() {
    return { hasError: true };
  }

  componentDidCatch(error: *, errorInfo: *) {
    const { name, children } = this.props;
    console.error('Error occured in Component:', name, error, errorInfo);
    console.error('children was', children);
  }

  render() {
    const { hasError } = this.state;
    const { children } = this.props;
    if (hasError) {
      // If an error occurs inside the Editable, try render the children on their own
      return children;
    }
    return <SbEditable {...this.props} />;
  }
}

const NonEditor = ({ children }: *) => children;

const StoryblokEditor =
  !CONFIG.storyblok || CONFIG.storyblok.version === 'published'
    ? NonEditor
    : StoryblokEditorWithErrorBoundary;

export default StoryblokEditor;
